import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  selectedUserId: number | null;
}

const initialState: UserState = {
  selectedUserId: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setSelectedUser(state, action: PayloadAction<number | null>) {
      state.selectedUserId = action.payload;
    },
  },
});

export const { setSelectedUser } = userSlice.actions;
export default userSlice.reducer;
